import { useState } from "react";
import type { StaffDetail } from "@/api/guide";
import { THEME } from "../constants";

interface IntroSectionProps {
  guide: StaffDetail;
}

export default function IntroSection({ guide }: IntroSectionProps) {
  const [introExpanded, setIntroExpanded] = useState(false);

  if (!guide.introduction) return null;

  return (
    <div className="mx-4 mt-4 p-4 rounded-2xl" style={{ background: "rgba(255,255,255,0.05)" }}>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-semibold text-white">自我介绍</h2>
        <button
          onClick={() => setIntroExpanded(!introExpanded)}
          className="px-3 py-1 rounded-full text-xs font-medium cursor-pointer transition-all"
          style={{
            background: introExpanded ? "transparent" : THEME.primary,
            color: introExpanded ? THEME.primary : "#FFF",
            border: introExpanded ? `1px solid ${THEME.primaryBorder}` : "none",
          }}
        >
          {introExpanded ? "收起" : "展开"}
        </button>
      </div>
      <p
        className="text-xs leading-relaxed whitespace-pre-line"
        style={{
          color: "rgba(255,255,255,0.65)",
          display: !introExpanded ? "-webkit-box" : undefined,
          WebkitLineClamp: !introExpanded ? 3 : undefined,
          WebkitBoxOrient: !introExpanded ? "vertical" : undefined,
          overflow: !introExpanded ? "hidden" : undefined,
        }}
      >
        {guide.introduction}
      </p>
      {(guide.height > 0 || guide.age > 0) && (
        <div className="mt-2 pt-3 border-t flex flex-wrap items-center gap-x-3 gap-y-1" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
          {guide.height > 0 && <span className="text-xs" style={{ color: "rgba(255,255,255,0.65)" }}>身高{guide.height}</span>}
          {guide.weight > 0 && <span className="text-xs" style={{ color: "rgba(255,255,255,0.65)" }}>体重{guide.weight}kg</span>}
          {guide.age > 0 && <span className="text-xs" style={{ color: "rgba(255,255,255,0.65)" }}>年龄{guide.age}</span>}
        </div>
      )}
    </div>
  );
}
